import { useMutation } from '@tanstack/react-query'

import { IApiBaseTypes } from '@/types/query-api'
import { IResponseType } from '@/types/response-type'

import { IUpdateDocumentsParamsType, IUpdateImageResponseType } from './type'
import { APIFileInstance } from '@/utils/functions/instance'

export function useUpdateDocuments({
  disableToast,
  ...rest
}: IApiBaseTypes<{}> = {}) {
  return useMutation({
    mutationFn: async (payload: IUpdateDocumentsParamsType) => {
      const newPayload = {
        file: payload.file,
        file_extension: payload.file_extension,
        document_type: payload.document_type
      }
      return await APIFileInstance<IUpdateImageResponseType>({
        url: `mrf/documents/${payload.document_id}/`,
        method: 'put',
        data: newPayload
      })
    },
    mutationKey: ['update-document'],
    retry: 0,
    ...rest
  })
}
